import { render, staticRenderFns } from "./app-news.vue?vue&type=template&id=22ff392e&scoped=true&"
import script from "./app-news.vue?vue&type=script&lang=ts&"
export * from "./app-news.vue?vue&type=script&lang=ts&"
import style0 from "./app-news.vue?vue&type=style&index=0&id=22ff392e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff392e",
  null
  
)

export default component.exports